import React from "react";

import { Icon } from "@partials";
import { getLocalization } from "@utilities";

import { LocalizationProps, IconsListProps } from "../types";

import ColumnsOffset from "./layout/ColumnsOffset";

type AlertNoAddressFoundProps = {
  inputValue: string;
  alertSource?: string;
} & LocalizationProps &
  IconsListProps;

const AlertNoAddressFound: React.FC<AlertNoAddressFoundProps> = ({
  iconsList,
  inputValue,
  localization,
  alertSource = "0",
}) => {
  const { infoCircleRed } = iconsList;

  return (
    <ColumnsOffset col="22" offset="1">
      <div className="mb-8 flex items-start rounded-sm bg-white py-3 px-4" data-testid={`alert-${alertSource}`}>
        <Icon
          name={infoCircleRed.name}
          viewBox={infoCircleRed.viewbox}
          alt={infoCircleRed.alt}
          svg={infoCircleRed.svg}
          className="icon mr-3 inline h-6 w-6 shrink-0 fill-red-corporate"
        />
        <div className="words-break text-xs" role="alert" aria-live="assertive">
          {getLocalization(localization, "Branches_AlertMessageNoResultsPart1")}
          {inputValue ? null : " "}
          {inputValue ? <span className="mx-1 font-bold">{`"${inputValue}"`}</span> : null}
          {getLocalization(localization, "Branches_AlertMessageNoResultsPart2")}
        </div>
      </div>
    </ColumnsOffset>
  );
};

export default AlertNoAddressFound;
